import React, { useState, useEffect } from "react";
import { Modal, Container } from "@mui/material";
import { useWindowDimensions } from "../../App/useWindowDimensions.jsx";
import OasGrid from "./OasGrid.jsx";

const OasViewPort = ({
    clientJson,
    scen_uuid,
    scen_name,
    show,
    onClose,
}) => {
    const { winHeight, winWidth } = useWindowDimensions();
    const [expand, setExpand] = useState(false)

    return (
        <Modal
            sx={{ overflow: "scroll", m: 20 }}
            anchor="right"
            open={show}
            onClose={onClose}
        >
            <Container maxWidth="true">
                <OasGrid
                    clientJson={clientJson}
                    scen_uuid={scen_uuid}
                    scen_name={scen_name}
                    key={"CPP-View-port-Oas-Grid"}
                    width={expand ? winWidth - 35 * 4 : winWidth - (600 + 20) * 4}
                    height={expand ? winHeight - 35 * 4 : winHeight - 500}
                    onExpand={() => { console.log(expand); setExpand(!expand) }}
                    onClose={onClose}
                />
            </Container>
        </Modal>
    );
};

export default OasViewPort;
